import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties('GET_DUPLICATES', 'DELETE_DUPLICATE');
